export var dataHooks = {
  RadioGroupRadioContainer: 'RadioGroup-radio-container'
};